import Gravity from "Gravity";

import { searchResult } from "./helpers/search-result";
import initHeader from "./header";
import initScrollToTopButton from "./back-to-top-button";
import initAttestation from "./attestation";
import initMutualFundPage from "./mutual-fund-page-filter";
import initContentHubPage from "./content-hub";
import initPardotCookieBar from "./pardot-cookie-bar";
import onetrustDetect from "./onetrust-detect";
import { initPardotIntegrationForm } from "./pardot-integration-form";

// In this function you add all the code that needs to run after the document is ready
Gravity.ready(() => {
    searchResult();
    setTimeout(initHeader, 0);
    initScrollToTopButton();
    initAttestation();
    initMutualFundPage();
    initContentHubPage();
    initPardotCookieBar();
    initPardotIntegrationForm();
    onetrustDetect();
});

// Code that doesn't need "document ready" goes here
Gravity.handleFirstTab();

// Global modules animation
Gravity.addInViewportClass('[data-animated-section="true"]', "in-view");
